export default __webpack_public_path__ + "static/media/commercial.d3df7610.jpg";